export const PackageIcon = (props: { width?: string; height?: string; fill?: string }) => {
  const { width = "24px", height = "24px", fill = "#5C5F62" } = props;

  return (
    <svg fill={fill} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="15 0 74 84">
      <path
        d="M53,53.6V78c0,0.6,0.4,1,1,1c0.2,0,0.4,0,0.5-0.1c4.8-2.7,19.4-11,19.4-11c1.9-1.1,3.1-3.1,3.1-5.3V40.7
   c0-0.6-0.4-1-1-1c-0.2,0-0.4,0-0.5,0.1L54,51.9C53.4,52.2,53,52.9,53,53.6z M51,46.8l21.6-12.1c0.5-0.3,0.6-0.9,0.3-1.4
   c-0.1-0.1-0.2-0.2-0.3-0.3c-4.8-2.7-19.5-11.1-19.5-11.1c-1.9-1.1-4.3-1.1-6.2,0c0,0-14.7,8.3-19.5,11.1c-0.5,0.3-0.6,0.9-0.3,1.4
   c0.1,0.1,0.2,0.2,0.3,0.3L49,46.8C49.6,47.1,50.4,47.1,51,46.8z M46,51.9L24.5,39.8c-0.5-0.3-1.1-0.1-1.4,0.4
   C23,40.3,23,40.5,23,40.7v21.8c0,2.2,1.2,4.2,3.1,5.3c0,0,14.6,8.3,19.4,11c0.5,0.3,1.1,0.1,1.4-0.4C47,78.2,47,78,47,77.9V53.6
   C47,52.9,46.6,52.2,46,51.9z"
      />
    </svg>
  );
};
